export default __webpack_public_path__ + "static/media/sorter.2ea8958c.svg";